import { render, staticRenderFns } from "./AssetCompany.vue?vue&type=template&id=e4ddd2a6&scoped=true&"
import script from "./AssetCompany.vue?vue&type=script&lang=js&"
export * from "./AssetCompany.vue?vue&type=script&lang=js&"
import style0 from "./AssetCompany.vue?vue&type=style&index=0&id=e4ddd2a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ddd2a6",
  null
  
)

export default component.exports